import custom_axios from "../axios";
export const generate_product_metadata = async (formData) => {
  try {
    const response = await custom_axios.post(
      `/product/upload-and-generate-metadata`,
      formData
    );
    return response;
  } catch (error) {
    console.error("Failed to generate content:", error);
    throw error;
  }
};

export const get_all_products = async () => {
  try {
    const response = await custom_axios.get(`/product/`);
    return response;
  } catch (error) {
    console.error("Failed to fetch product:", error);
    throw error;
  }
};

export const get_one_product = async (searchString) => {
  try {
    const response = await custom_axios.get(`/product/search/${searchString}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch product:", error);
    throw error;
  }
};

export const get_products_by_name = async (searchString) => {
  try {
    const response = await custom_axios.get(`/product/search_variants/${searchString}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch product:", error);
    throw error;
  }
};